import { ICON_TYPES } from '../constants';
import { IconPropsType } from '../IconProps.type';
export const FoodIcon = (props: IconPropsType): JSX.Element => {
  const { fill = '#43494F' } = props;
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13119_26444)">
        <path
          d="M1.17524 6.33346C0.4037 4.91368 0.00254732 3.32231 0.00886249 1.70646C0.00866987 1.3692 0.108533 1.03946 0.295812 0.758978C0.483092 0.478496 0.74937 0.259875 1.06095 0.130785C1.37252 0.00169565 1.71539 -0.0320608 2.04616 0.0337884C2.37693 0.0996375 2.68073 0.262132 2.91911 0.500707L7.42536 5.30358C7.15138 5.88069 7.00769 6.511 7.00449 7.14983C7.00449 7.24871 7.02636 7.34408 7.03249 7.44208L1.75886 1.81933C1.77003 3.10165 2.0954 4.36168 2.70649 5.48908C3.71225 7.42244 5.03255 9.17506 6.61336 10.6752L5.37524 11.9177C3.66867 10.308 2.24841 8.41959 1.17524 6.33346ZM11.2981 13.414L9.94799 14.7658C11.4333 15.435 13.0608 15.7271 14.6861 15.6163L19.7156 20.9617L20.9896 19.763L15.3275 13.7255C13.9825 14.0138 12.5828 13.9055 11.2981 13.414ZM11.9929 11.4811C12.485 11.9724 13.152 12.2483 13.8474 12.2483C14.5428 12.2483 15.2098 11.9724 15.702 11.4811L21.0089 6.16896L19.7751 4.93083L14.4682 10.2438C14.3042 10.4079 14.0816 10.5 13.8496 10.5C13.6176 10.5 13.3951 10.4079 13.231 10.2438L12.6106 9.62521L18.537 3.69358L17.3006 2.45546L11.3751 8.38796L10.7574 7.76933C10.676 7.68807 10.6115 7.59157 10.5674 7.48534C10.5234 7.37912 10.5007 7.26526 10.5007 7.15027C10.5007 7.03528 10.5234 6.92142 10.5674 6.8152C10.6115 6.70897 10.676 6.61247 10.7574 6.53121L16.0642 1.21821L14.827 -0.019043L9.52011 5.29396C9.0288 5.78682 8.75292 6.45435 8.75292 7.15027C8.75292 7.84619 9.0288 8.51372 9.52011 9.00658L10.1379 9.62521L0.0298625 19.7437L1.26624 20.981L11.3751 10.8625L11.9929 11.4811Z"
          fill="#43494F"
        />
      </g>
    </svg>
  );
};

FoodIcon.iconType = ICON_TYPES.FOOD;
